import { Components, Theme } from '@mui/material';
import { muiThemeBreakpoints } from './breakpoints';

const media = `@media (min-width: ${muiThemeBreakpoints.sm}px)`;

export default <Components<Theme>>{
  MuiButton: {
    styleOverrides: {
      contained: {
        boxShadow:
          '0 1px 1px 0 rgba(0,0,0,0.14), 0 2px 1px -1px rgba(0,0,0,0.12), 0 1px 3px 0 rgba(0,0,0,0.20)',
      },
      containedSecondary: ({ theme: { palette } }) => ({
        backgroundColor: palette.error.main,
        '&:hover': {
          backgroundColor: palette.error.dark,
        },
      }),
    },
  },
  MuiIconButton: {
    styleOverrides: {
      root: () => ({
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.03)',
        },
      }),
      colorSecondary: ({ theme: { palette } }) => ({
        color: palette.error.main,
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.03)',
        },
      }),
    },
  },
  MuiPaper: {
    styleOverrides: {
      elevation1: {
        boxShadow:
          '0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)',
      },
    },
  },
  MuiTableCell: {
    styleOverrides: {
      root: ({ theme: { typography, palette } }) => ({
        ...typography.body1,
        borderBottom: `1px solid ${palette.divider}`,
      }),
    },
  },
  MuiTypography: {
    styleOverrides: {
      gutterBottom: {
        marginBottom: 8,
      },
    },
  },
  MuiPickersDateRangePickerInput: {
    styleOverrides: {
      root: {
        justifyContent: 'space-between',
      },
    },
  },
  MuiTabs: {
    styleOverrides: {
      indicator: ({ theme: { palette } }) => ({
        height: '3px',
        backgroundColor: palette.background.paper,
      }),
      scroller: {
        '&.MuiTabs-fixed': {
          padding: '0 20px',
        },
      },
    },
  },
  MuiTab: {
    styleOverrides: {
      root: {
        [media]: {
          minWidth: '120px',
        },
      },
    },
  },
};
